module.exports = __webpack_public_path__ + "static/wikipedia-cognitive-biases-full-9240feb468e76703627a7ef137870e6a.png";